// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer style={{ backgroundColor: 'black', padding: '10px 20px', textAlign: 'center' }}>
            <p style={{ color: 'white', margin: 0 }}>
                Jackpot Concierge 2026 &copy; All Rights Reserved.
                {' | '}
                <Link to="/" style={{ color: 'skyblue', textDecoration: 'none' }}>Home</Link>
                {' | '}
                <Link to="/contact" style={{ color: 'skyblue', textDecoration: 'none' }}>Contact Us</Link>
                {' | '}
                <Link to="/privacy-policy" style={{ color: 'skyblue', textDecoration: 'none' }}>Privacy Policy</Link>
                {' | '}
                Jackpot Concierge is a WorldVia Travel Network Independent Agency
            </p>
        </footer>
    );
};

export default Footer;
